<section class="w-100 float-left partner_section">
    <div class="container">
        <div class="main_title d-flex justify-content-center" >
            <h1 class="line"><span>Our</span> Partners </h1>
        </div>
        <h2 class="sub_title text-center w-100 float-left" >We Feel Pride in Having Partnerships with Some of the Most Reputed Companies in the World</h2>
        <div class="w-100 float-left">
            <div class="row partner_logo_box">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center align-items-center" >
                    <div class="partner_logo_img">
                        <img src="assets/images/partners/amazon.png" alt="our partners"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center align-items-center" >
                    <div class="partner_logo_img">
                        <img src="assets/images/partners/partner.png" alt="our partners"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center align-items-center" >
                    <div class="partner_logo_img">
                        <img src="assets/images/partners/upwork.png" alt="our partners"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center align-items-center" >
                    <div class="partner_logo_img">
                        <img src="assets/images/partners/good.png" alt="our partners"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center align-items-center" >
                    <div class="partner_logo_img">
                        <img src="assets/images/partners/guru.png" alt="our partners"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center align-items-center" >
                    <div class="partner_logo_img">
                        <img src="assets/images/partners/clutouc.png" alt="our partners"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center align-items-center" >
                    <div class="partner_logo_img">
                        <img src="assets/images/partners/gesia.png" alt="our partners"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>